export const SELECTION_LIST_PLACEHOLDER = 'selectionListPlaceholder';
export const TEXT_MARK_PLACEHOLDER = 'textMarkPlaceholder';

export type SelectionFlag = 'M' | 'E';
